import toast from "react-hot-toast";

export function toastOnError(err: unknown, message: string) {
  if (err instanceof Error) {
    toast.error(`${message}: ${err.message}`);
  } else {
    toast.error(message);
  }
}
